import React, { useEffect, useState } from 'react'
import { Button, Row, Space, Col, Tooltip, message, Modal } from 'antd'
import { blue } from '../../../color'
import { UserOutlined } from '@ant-design/icons'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
} from '../../../constants'
import { inject, observer } from 'mobx-react'

import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import SelectListComponent from '../../../components/Common/SelectListComponent'
import SelectUserButton from '../../../components/Common/SelectUserButton'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import useOpenItem from '../../../hooks/useOpenItem'

const PopupAddPersonVote = props => {
  const {
    isVisibleAddPersonVote,
    handleCloseAddPersonVote,
    selectPeopleStore,
    loadingAnimationStore,
    voteStore,
    workStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    assigneePopupType,
    setSelectUserData,
    clearSelectUserData,
  } = selectPeopleStore
  const { workDetail } = workStore
  const { assignees, title, code } = workDetail
  const {} = voteStore
  const [voterList, setVoterList] = useState([])
  const {
    isOpen: isLoading,
    handleOpen: handleLoading,
    handleClose: handleCancelLoading,
  } = useOpenItem()
  useEffect(() => {
    if (!assigneePopupType) return
    setVoterList([
      ...selectUserData[assigneePopupType],
      ...selectDepartmentData[assigneePopupType],
    ])
  }, [selectUserData, selectDepartmentData, assigneePopupType])

  useEffect(() => {
    if (!isVisibleAddPersonVote) return

    selectPeopleStore.setAssigneePopupType(ASSIGNEE_TYPE.USER)
    selectPeopleStore.setSelectUserData(
      selectPeopleStore.convertSelectDataObj(voteStore?.voteDetail)
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisibleAddPersonVote, voteStore?.voteDetail])

  const handleSubmitSelectVoter = async () => {
    setIsVisibleSelectUserDepartmentPopup(false)
    const handlerList = assignees.filter(
      el =>
        el.permission === ASSIGNEE_TYPE.HANDLER &&
        el.assignee_code !== 'admin' &&
        el.assignee_type === 'USER'
    )
    const newVoterList = voterList.map(voter => ({ assignee_code: voter.id }))
    const newHandlerList = voterList
      .map(voter => ({ ...voter, assignee_code: voter.id }))
      .filter(
        voter =>
          !handlerList.some(
            handler => handler.assignee_code === voter.assignee_code
          )
      )
    const remove_items = (voteStore?.voteDetail || [])
      .map(voter => ({ assignee_code: voter.assignee_code }))
      .filter(
        prev =>
          !newVoterList.some(
            voter => voter.assignee_code === prev.assignee_code
          )
      )
    const new_items = newVoterList.filter(
      voter =>
        !(voteStore?.voteDetail || []).some(
          prev => prev.assignee_code === voter.assignee_code
        )
    )

    const data = {
      document_code: code,
      document_title: title,
      type: 'WORK',
      vote_users: {
        remove_items: remove_items,
        new_items: new_items,
      },
      current_assignee: handlerList.concat(newHandlerList),
    }

    if (
      data.vote_users.new_items.length > 0 ||
      data.vote_users.remove_items.length > 0
    ) {
      handleLoading()
      try {
        if (voteStore?.voteDetail?.length > 0) {
          await voteStore.updatePersonVote(code, data)
        } else {
          await voteStore.createVote(data)
        }
        await voteStore.getVoteDetail(code)
        await workStore.getWorkDetail(code)
        message.success('Bạn đã cập nhật lấy ý kiến!')
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra')
      } finally {
        handleCancelLoading()
      }
    } else message.error('Bạn chưa chọn người lấy ý kiến')
    handleCloseAddPersonVote()
  }
  // console.log('voterList', voterList)
  return (
    <div style={{ position: 'relative' }}>
      <Modal
        title="Chọn người lấy ý kiến"
        visible={isVisibleAddPersonVote}
        onCancel={() => {
          handleCloseAddPersonVote()
          clearSelectUserData()
        }}
        footer={null}
        width={600}
        wrapClassName="custom-modal-wrapper"
      >
        <SelectUserButton
          title="Chọn người:"
          handleOnClick={() => {
            setIsVisibleSelectUserDepartmentPopup(true)
            handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.USER)
          }}
        />
        <SelectListComponent userList={voterList} />

        <div className="custom-modal-footer" style={{ marginTop: 32 }}>
          <Button
            danger
            style={{ width: 140, borderRadius: 8, height: 40 }}
            onClick={() => {
              handleCloseAddPersonVote()
              clearSelectUserData()
            }}>
            Hủy
          </Button>
          <Button
            type="primary"
            style={{ width: 140, borderRadius: 8, height: 40 }}
            onClick={handleSubmitSelectVoter}>
            Cập nhật
          </Button>
        </div>

        <SelectPeoplePopup
          disableSelectDepartment
          handleCancelSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
        <SpinnerInlineComponent
          sizeSpin={'small'}
          tip="Đang tải dữ liệu..."
          isLoading={isLoading}
          backGround={'#ffffffc7'}
        />
      </Modal>
    </div>
  )
}

PopupAddPersonVote.propTypes = {}

export default inject(
  'workStore',
  'voteStore',
  'selectPeopleStore',
  'loadingAnimationStore'
)(observer(PopupAddPersonVote))
